import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ContactListPage } from './contact-list';
import { UserHeaderComponentModule } from '../../components/header/header.module';

@NgModule({
  declarations: [
    ContactListPage,
  ],
  imports: [
    IonicPageModule.forChild(ContactListPage),
    UserHeaderComponentModule
  ],
})
export class ContactListPageModule {}



// WEBPACK FOOTER //
// ./src/pages/contact-list/contact-list.module.ts